import { useTranslation } from '@hopin-team/provider-translation';
import React from 'react';

import NoResultsFrame1 from '../../images/no-results-frame1.png';
import NoResultsFrame2 from '../../images/no-results-frame2.png';
import NoResultsFrame3 from '../../images/no-results-frame3.png';
import { getHost } from '../../services/endpoints';
import { Button } from '..';

export const NoResults = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center mt-6">
      <div className="relative w-[160px] h-[160px] rounded-full bg-[#9cd7f2] overflow-hidden mb-6">
        <img
          className="absolute w-[120px] h-[110px] left-[42px] top-[18px]"
          src={NoResultsFrame1}
          alt={t('analytics.no-results')}
        />
        <img
          className="absolute w-[65px] h-[38px] left-[56px] top-[122px]"
          src={NoResultsFrame2}
          alt={t('analytics.no-results')}
        />
        <img
          className="absolute w-[62px] h-[87px] left-[-3px] top-[61px]"
          src={NoResultsFrame3}
          alt={t('analytics.no-results')}
        />
      </div>
      <div className="font-inter font-medium text-center text-sm leading-5 w-72 text-gray-750 mb-6">
        {t('analytics.no-results-onload')}
      </div>
      <div className="">
        <Button
          onClick={() => {
            window.location.href = `${getHost()}/create-event-wizard`;
          }}
          pattern="outline"
          kind="secondary"
          size="medium"
          className="border-neutral-b4 !rounded-lg outline-none focus-visible:border-blue-500 focus-visible:outline focus-visible:ring-1 focus-visible:outline-1 focus-visible:outline-blue-500 focus-visible:outline-offset-0"
        >
          <span className={'font-medium'}>{t('analytics.create-event')}</span>
        </Button>
      </div>
    </div>
  );
};
